import {
  OnBoardingGoalSelectScreenType,
  OnBoardingScreenOptions,
  OnBoardingScreenOptionType,
  OnBoardingScreensType,
} from '@mindly/ui-components';

export function calculateProgress(
  screens: Record<string, OnBoardingScreensType>,
  currentScreenId: string,
  currentGoalScreenCount?: number
) {
  const goalScreen = Object.values(screens).find((screen) => screen.type === OnBoardingScreenOptions.GOAL);
  const totalGoalScreensCount = (goalScreen as OnBoardingGoalSelectScreenType)?.maxSelectionCount ?? 0;

  const totalScreens = Object.keys(screens).length + totalGoalScreensCount;
  const visitedScreens = new Set<string>();

  if (totalScreens === 0)
    return {
      progress: 0,
      currentCount: 0,
      totalCount: 0,
    };

  function traverseScreens(screenId: string) {
    if (visitedScreens.has(screenId)) return;

    visitedScreens.add(screenId);
    const screen = screens[screenId];

    if (screen?.rules) {
      Object.values(screen.rules).forEach((rule) => {
        if (rule.action?.target) {
          traverseScreens(rule.action.target);
        }
      });
    }
  }

  for (let i = 1; i <= totalGoalScreensCount; i++) {
    visitedScreens.add(`${currentScreenId}-${i}`);
  }

  traverseScreens(currentScreenId);

  const visitedCount = visitedScreens.size - (currentGoalScreenCount ?? 0);
  const progress = visitedCount / totalScreens;

  return {
    progress: 1 - progress,
    currentCount: totalScreens - visitedCount + 1,
    totalCount: totalScreens,
  };
}

export const getFiltrationAnswerIds = (ids: string[], options: OnBoardingScreenOptionType[]): string[] => {
  return ids
    .map((id) => {
      const option = options.find((i) => i.id === id);
      if (option) {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return option?.filtrationAnswerId || option.id;
      }
      return '';
    })
    .filter(Boolean);
};
